'use strict';

/**
 * @name webview
 */

exports.open = require('./open.js');
exports.back = require('./back.js');
exports.close = require('./close.js');
exports.closeAll = require('./close-all.js');

exports.modal = require('./modal.js');
exports.dismiss = require('./dismiss.js');

exports.setTitle = require('./set-title.js');
exports.setMenus = require('./set-menus.js');
exports.setComplexTitle = require('./set-complex-title.js');

exports.setBackAction = require('./set-back-action.js');



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/webview/index.js
// module id = 283
// module chunks = 10 11 12 13 14 15 16 17 18 19